import type { BaseQueryApi } from "@reduxjs/toolkit/query";

import { baseQuery } from "./base-query";

export type ExecuteBaseQuery = (
  arg: Parameters<typeof baseQuery>[0]
) => ReturnType<typeof baseQuery>;

export function createQueryFn<TArg, TReturn>(
  handler: (arg: TArg, executeBaseQuery: ExecuteBaseQuery) => TReturn
): (
  arg: TArg,
  api: BaseQueryApi,
  extraOptions: unknown,
  executeBaseQuery: ExecuteBaseQuery
) => TReturn {
  return (arg, _api, _extraOptions, executeBaseQuery) => handler(arg, executeBaseQuery);
}
